export const statusTextMap = {
  pending_enroll: "Pending Enroll",
  in_progress: "In Progress",
  successful: "Successful",
  rejected: "Rejected",
  pending_unenroll: "Pending Unenroll",
  unenrolled: "Unenrolled"
}

export const STATUS_OPTIONS = [
  "pending_enroll",
  "in_progress",
  "successful",
  "rejected",
  "pending_unenroll",
  "unenrolled"
]

// Backend validates the same table and returns 400 "Invalid status" on any other transition
export const STATUS_TRANSITIONS = {
  pending_enroll: ["in_progress", "rejected"],
  in_progress: ["successful", "rejected"],
  successful: ["pending_unenroll"],
  pending_unenroll: ["unenrolled", "successful"],
  rejected: [],
  unenrolled: []
}
